export default __webpack_public_path__ + "static/media/case-study6.69879159.jpg";